import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ChatMessage} from '../../../models/chat-message';
import {IvyFaceComponent} from '../../ivy-face/ivy-face.component';
import { ChatOption } from 'projects/chat-common/src/lib/models/chat.option';
import { CommonModule } from "@angular/common";

@Component({
  selector: 'app-single-input-card',
  standalone: true,
  imports: [
    IvyFaceComponent,
    CommonModule
],
  templateUrl: './single-input-card.component.html',
  styleUrl: './single-input-card.component.scss'
})
export class SingleInputCardComponent {
  @Input()
  data: ChatMessage;

  @Output()
  onSelect: EventEmitter<ChatOption> = new EventEmitter()

  selectedOption: ChatOption | null = null;

  @Input()
  showOptions: boolean;

  select(option: ChatOption) {
    this.selectedOption = option;
    this.onSelect.emit(option);
  }

 getOptionClass(option: ChatOption): string {
  const count = this.data.answer.options.length;
  const isSelected = this.selectedOption === option;

  if (isSelected) {
    return 'bg-[#DAD6FB] border-[#857AEF]';
  }

  return count > 2
    ? 'bg-white border-[#DDB9FD]'
    : 'bg-white border-[#000000]';
}

}
